module.exports = __webpack_public_path__ + "static/media/banco_occidente.4670c412.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/new-order/payment-method/banco_occidente.png
// module id = 1995
// module chunks = 0